import React, { useState, useEffect } from "react";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  const [manage, setManage] = useState(false);
  const [prefs, setPrefs] = useState({ analytics: true, marketing: true });

  useEffect(() => {
    if (!localStorage.getItem("ck_cookie_consent")) setShow(true);
  }, []);

  const save = (consent) => {
    localStorage.setItem("ck_cookie_consent", JSON.stringify({ essential: true, ...consent, at: Date.now() }));
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-4 sm:p-6" data-testid="cookie-banner">
      <div className="max-w-3xl mx-auto bg-white border border-brand-border shadow-2xl rounded-sm p-6 ck-fade-up">
        <h4 className="font-serif-display text-xl mb-2">Your privacy matters</h4>
        <p className="text-sm text-muted-foreground leading-relaxed mb-4">
          We use essential cookies to make our shop work, plus optional analytics and marketing cookies to improve your experience.
          You can accept all, reject optional cookies, or manage your preferences. See our <a href="/cookie-policy" className="underline">Cookie Policy</a>.
        </p>
        {manage && (
          <div className="space-y-2 mb-4 text-sm">
            <label className="flex items-center justify-between border border-brand-border rounded-sm px-3 py-2 opacity-70">
              <span>Essential cookies (always on)</span>
              <input type="checkbox" checked disabled />
            </label>
            <label className="flex items-center justify-between border border-brand-border rounded-sm px-3 py-2">
              <span>Analytics cookies</span>
              <input type="checkbox" checked={prefs.analytics} onChange={(e) => setPrefs({ ...prefs, analytics: e.target.checked })} data-testid="cookie-analytics" />
            </label>
            <label className="flex items-center justify-between border border-brand-border rounded-sm px-3 py-2">
              <span>Marketing cookies</span>
              <input type="checkbox" checked={prefs.marketing} onChange={(e) => setPrefs({ ...prefs, marketing: e.target.checked })} data-testid="cookie-marketing" />
            </label>
          </div>
        )}
        <div className="flex flex-wrap gap-3">
          <button onClick={() => save({ analytics: true, marketing: true })} className="bg-brand-ink text-white px-6 py-2.5 rounded-sm text-sm hover:bg-brand-pink hover:text-brand-ink transition-colors" data-testid="cookie-accept">Accept all</button>
          <button onClick={() => save({ analytics: false, marketing: false })} className="border border-brand-ink px-6 py-2.5 rounded-sm text-sm hover:bg-brand-blush transition-colors" data-testid="cookie-reject">Reject optional</button>
          {!manage
            ? <button onClick={() => setManage(true)} className="px-4 py-2.5 text-sm underline" data-testid="cookie-manage">Manage preferences</button>
            : <button onClick={() => save(prefs)} className="px-4 py-2.5 text-sm underline" data-testid="cookie-save">Save preferences</button>}
        </div>
      </div>
    </div>
  );
}
